// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var MarginInfoGroupType;
(function (MarginInfoGroupType) {
    MarginInfoGroupType[MarginInfoGroupType["KEY_GROUP_RISKS"] = 0] = "KEY_GROUP_RISKS";
    MarginInfoGroupType[MarginInfoGroupType["KEY_GROUP_FEES"] = 1] = "KEY_GROUP_FEES";
})(MarginInfoGroupType || (MarginInfoGroupType = {}));
export var MarginInfoItemType;
(function (MarginInfoItemType) {
    // 1.Risks
    MarginInfoItemType[MarginInfoItemType["KEY_BALANCE"] = 0] = "KEY_BALANCE";
    MarginInfoItemType[MarginInfoItemType["KEY_AVAILABLE_FUNDS"] = 1] = "KEY_AVAILABLE_FUNDS";
    MarginInfoItemType[MarginInfoItemType["KEY_INCOMING_FUNDS"] = 2] = "KEY_INCOMING_FUNDS";
    MarginInfoItemType[MarginInfoItemType["KEY_MARGIN_AVAILABLE"] = 3] = "KEY_MARGIN_AVAILABLE";
    MarginInfoItemType[MarginInfoItemType["KEY_IMPACT_ON_FUNDS"] = 4] = "KEY_IMPACT_ON_FUNDS";
    MarginInfoItemType[MarginInfoItemType["KEY_IMPACT_ON_MARGIN"] = 5] = "KEY_IMPACT_ON_MARGIN";
    MarginInfoItemType[MarginInfoItemType["KEY_AFTER_TRADE_FUNDS"] = 6] = "KEY_AFTER_TRADE_FUNDS";
    MarginInfoItemType[MarginInfoItemType["KEY_AFTER_TRADE_MARGIN"] = 7] = "KEY_AFTER_TRADE_MARGIN";
    MarginInfoItemType[MarginInfoItemType["KEY_BLOCKED_FOR_STOCKS"] = 8] = "KEY_BLOCKED_FOR_STOCKS";
    MarginInfoItemType[MarginInfoItemType["KEY_SPREAD_INIT_LOSS"] = 9] = "KEY_SPREAD_INIT_LOSS";
    MarginInfoItemType[MarginInfoItemType["KEY_PL_PER_TICK"] = 10] = "KEY_PL_PER_TICK";
    MarginInfoItemType[MarginInfoItemType["KEY_ALLOW_SHORT_POSITIONS"] = 11] = "KEY_ALLOW_SHORT_POSITIONS";
    MarginInfoItemType[MarginInfoItemType["KEY_EST_AVAILABLE_CASH"] = 12] = "KEY_EST_AVAILABLE_CASH";
    MarginInfoItemType[MarginInfoItemType["BLOCKED_FOR_FIXED_INCOME"] = 13] = "BLOCKED_FOR_FIXED_INCOME";
    // 2.Fees
    MarginInfoItemType[MarginInfoItemType["KEY_FILL_PER_LOT"] = 14] = "KEY_FILL_PER_LOT";
    MarginInfoItemType[MarginInfoItemType["KEY_ORDER_PER_LOT"] = 15] = "KEY_ORDER_PER_LOT";
    MarginInfoItemType[MarginInfoItemType["KEY_ORDER_PER_LOT_WITH_FIXED_PART"] = 16] = "KEY_ORDER_PER_LOT_WITH_FIXED_PART";
    MarginInfoItemType[MarginInfoItemType["KEY_FILL_VOLUME"] = 17] = "KEY_FILL_VOLUME";
    MarginInfoItemType[MarginInfoItemType["KEY_FILL_VOLUME_WITH_MIN_PD"] = 18] = "KEY_FILL_VOLUME_WITH_MIN_PD";
    MarginInfoItemType[MarginInfoItemType["KEY_PER_FILL"] = 19] = "KEY_PER_FILL";
    MarginInfoItemType[MarginInfoItemType["KEY_PER_TRANSACTION"] = 20] = "KEY_PER_TRANSACTION";
    MarginInfoItemType[MarginInfoItemType["KEY_PER_PHONE_TRANSACTION"] = 21] = "KEY_PER_PHONE_TRANSACTION";
    MarginInfoItemType[MarginInfoItemType["KEY_VAT"] = 22] = "KEY_VAT";
    MarginInfoItemType[MarginInfoItemType["KEY_ORDER_VOLUME"] = 23] = "KEY_ORDER_VOLUME";
    MarginInfoItemType[MarginInfoItemType["KEY_SHORT_SWAP_INFO"] = 24] = "KEY_SHORT_SWAP_INFO";
    MarginInfoItemType[MarginInfoItemType["KEY_FREE_COMMISSION"] = 25] = "KEY_FREE_COMMISSION";
    MarginInfoItemType[MarginInfoItemType["KEY_TOTAL_FEES"] = 26] = "KEY_TOTAL_FEES";
    MarginInfoItemType[MarginInfoItemType["KEY_LONG_SWAP"] = 27] = "KEY_LONG_SWAP";
    MarginInfoItemType[MarginInfoItemType["KEY_SHORT_SWAP"] = 28] = "KEY_SHORT_SWAP";
    MarginInfoItemType[MarginInfoItemType["KEY_ORDER_CARE"] = 29] = "KEY_ORDER_CARE";
    MarginInfoItemType[MarginInfoItemType["KEY_FILL_FACE_VALUE"] = 30] = "KEY_FILL_FACE_VALUE";
})(MarginInfoItemType || (MarginInfoItemType = {}));
